import { render, staticRenderFns } from "./AllianceList.vue?vue&type=template&id=6c4a8fd7&scoped=true&"
import script from "./AllianceList.vue?vue&type=script&lang=js&"
export * from "./AllianceList.vue?vue&type=script&lang=js&"
import style0 from "./AllianceList.vue?vue&type=style&index=0&id=6c4a8fd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4a8fd7",
  null
  
)

export default component.exports